import { LottieSpinner } from '@/components/LottieSpinner/LottieSpinner'
import { ArrowCircleRight } from 'iconsax-react'
import React from 'react'

interface StatusCardProps {
  accentColor: string
  bgColor: string
  icon?: React.ReactNode
  text: React.ReactNode
  isLoading?: boolean
  disabled?: boolean
  callback: () => void
}

export const StatusCard = ({
  accentColor,
  bgColor,
  icon,
  text,
  isLoading,
  disabled,
  callback,
}: StatusCardProps) => {
  const handleClick = () => {
    if (disabled || isLoading) {
      return
    }
    console.log('StatusCard clicked, calling callback')
    callback()
  }

  return (
    <div
      style={{ backgroundColor: bgColor }}
      className={`flex justify-between items-center w-full rounded-2xl py-4 px-3 ${
        disabled || isLoading
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:cursor-pointer hover:opacity-80'
      }`}
      onClick={handleClick}
    >
      <div className="flex gap-2 items-center">
        {icon && icon}
        <p className="text-sm font-medium" style={{ color: accentColor }}>
          {text}
        </p>
      </div>
      {isLoading ? (
        <div className="w-10 h-10">
          <LottieSpinner width={20} height={20} />
        </div>
      ) : (
        <ArrowCircleRight size="20" variant="Bold" color={accentColor} />
      )}
    </div>
  )
}
